angular.module("app").directive("isAllowedGlobalActions", [
    'settingsService',
    function (settingsService) {
        return {
            restrict: "A",
            replace: true,
            compile: function (element) {
                if (!settingsService.getSettings().allowGlobalActions) {
                    $(element).remove()
                }
            }
        }
    }
]);

angular.module("app").directive("isAllowedToShow", [
    'settingsService',
    function (settingsService) {
        return {
            restrict: "A",
            replace: true,
            scope: {
                isAllowedToShow: "="
            },
            link: function ($scope, element, $attr) {

                /*if (!settingsService.getSettings().allowGlobalActions && $scope.isAllowedToShow === "main.pages.add") {
                    $(element).remove()
                }*/
            }
        }
    }
]);